if (!customElements.get('bulk-order-hero')) {
  customElements.define('bulk-order-hero', class extends HTMLElement {
    connectedCallback() {
      this.updateHeaderSpace = this.updateHeaderSpace.bind(this);
      this.headerObserver = new ResizeObserver(this.updateHeaderSpace);
      this.observeHeader = () => {
        this.headerObserver.disconnect();
        const wrapper = document.getElementById('HeaderWrapper');
        if (wrapper) this.headerObserver.observe(wrapper);
        this.updateHeaderSpace();
      };
      this.observeHeader();
      document.addEventListener('shopify:section:load', this.observeHeader);
      const status = this.querySelector('[data-form-status]');
      if (status) status.focus({ preventScroll: true });
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.storageKey = `bulk-order-request:${location.pathname}`;
      if (!this.button) {
        try { sessionStorage.removeItem(this.storageKey); } catch (_) { /* Storage is optional. */ }
        return;
      }
      let requestId;
      try { requestId = sessionStorage.getItem(this.storageKey); } catch (_) { /* Storage is optional. */ }
      if (!/^[0-9a-f-]{36}$/i.test(requestId || '')) requestId = crypto.randomUUID();
      try { sessionStorage.setItem(this.storageKey, requestId); } catch (_) { /* Storage is optional. */ }
      this.querySelector('[data-request-id]').value = requestId;
      this.phone = this.form.elements.namedItem('contact[Phone number]');
      this.clearPhoneValidity = () => this.phone.setCustomValidity('');
      this.phone.addEventListener('input', this.clearPhoneValidity);
      this.onSubmit = this.saveInquiry.bind(this);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.button.disabled = false;
    }

    async saveInquiry(event) {
      const values = new FormData(this.form);
      const payload = {
        requestId: values.get('contact[Request ID]'),
        firstName: values.get('contact[First name]'),
        lastName: values.get('contact[Last name]'),
        email: values.get('contact[email]'),
        company: values.get('contact[Company]'),
        projectType: values.get('contact[Project type]'),
        details: values.get('contact[body]'),
        phone: values.get('contact[Phone number]'),
        showroom: values.get('contact[Showroom or store]'),
        referralSource: values.get('contact[How did you hear about HOMSEE]') || '',
        // Preserve the deployed API contract; installation is no longer offered.
        installationService: 'No',
        website: values.get('inquiry_website') || ''
      };
      const snapshot = JSON.stringify(payload);
      // A second native submit lets Shopify handle its CAPTCHA, redirect and email.
      if (this.savedSnapshot === snapshot) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const phone = this.form.elements.namedItem('contact[Phone number]');
      const phoneValue = phone.value.trim();
      const digits = phoneValue.replace(/\D/g, '').length;
      phone.setCustomValidity(/^[+\d\s().x#-]+$/i.test(phoneValue) && digits >= 7 && digits <= 20 ? '' : 'Please enter a valid phone number.');
      if (this.saving || !this.form.reportValidity()) return;
      const error = this.querySelector('[data-save-error]');
      error.hidden = true;
      this.saving = true;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      try {
        const endpoint = this.dataset.saveEndpoint;
        if (!endpoint || !/^\/apps\/[a-zA-Z0-9/_-]+$/.test(endpoint)) throw new Error('configuration');
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: snapshot,
          signal: AbortSignal.timeout(20000)
        });
        const result = await response.json();
        if (!response.ok || result.saved !== true) throw new Error('save');
        this.savedSnapshot = snapshot;
        // Re-read on submission: edits made during the request must be saved too.
        this.saving = false;
        this.button.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.form.requestSubmit(this.button);
      } catch (_) {
        error.textContent = 'We couldn’t send your request. Your details are still here—please try again in a moment.';
        error.hidden = false;
        this.saving = false;
        this.button.disabled = false;
        this.form.removeAttribute('aria-busy');
      }
    }

    updateHeaderSpace() {
      const header = document.getElementById('SiteHeader');
      const wrapper = document.getElementById('HeaderWrapper');
      // Only the first content section can sit behind the overlaid header.
      const section = this.closest('.shopify-section');
      const isFirst = section && !section.previousElementSibling;
      if (!isFirst || !header || header.dataset.overlay !== 'true' || !wrapper) {
        this.style.setProperty('--bulk-header-space', '0px');
        return;
      }
      // Preserve the initial space when the sticky header becomes fixed on scroll.
      if (header.classList.contains('site-header--stuck')) return;
      this.style.setProperty('--bulk-header-space', `${Math.ceil(wrapper.getBoundingClientRect().height)}px`);
    }

    disconnectedCallback() {
      this.headerObserver.disconnect();
      document.removeEventListener('shopify:section:load', this.observeHeader);
      if (this.form && this.onSubmit) this.form.removeEventListener('submit', this.onSubmit, true);
      this.phone?.removeEventListener('input', this.clearPhoneValidity);
    }
  });
}
